import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapLocationFormComponent from './mapLocationForm.component';

let mapLocationFormModule = angular.module('mapLocationForm', [
  uiRouter
])

.component('mapLocationForm', mapLocationFormComponent)

.name;

export default mapLocationFormModule;
